// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2Gdmv","title":"AfterBackImages_title__3MP6G","images":"AfterBackImages_images__1KDEi"};